import {SET_PAGE_SIZE, SET_PAGE_SIZES} from "../mutations-type";

const page = {
    state: {
        //页面显示数据条数
        page_size: 15,
        //可供选择的数据条数组
        page_sizes: [15, 50, 100],
    },
    mutations: {
        [SET_PAGE_SIZE]: (state, value) => {
            state.page_size = value;
        },
        [SET_PAGE_SIZES]: (state, value) => {
            state.page_sizes = value;
        },
    }
}
export default page
